import { createReducer } from "../../../generic/redux/createReducer";
import { pairActionTypeToReducer } from "../../../generic/redux/TypedRedux";

import type { UsageTrack } from "./UsageTrackActions";
import { CLEAR_TRACK_DATA, TRACK } from "./UsageTrackActionTypes";
import { type UsageTrackState, initialUsageTrackState } from "./UsageTrackState";

function trackReducer({ usage }: UsageTrackState, newUsage: UsageTrack) {
	return {
		usage: usage.concat(newUsage),
	};
}

function clearTrackReducer() {
	return {
		...initialUsageTrackState,
	};
}

export const UsageTrackReducer = createReducer<UsageTrackState>(initialUsageTrackState, {
	...pairActionTypeToReducer(TRACK, trackReducer),
	...pairActionTypeToReducer(CLEAR_TRACK_DATA, clearTrackReducer),
});
